import { render } from "./GerenciamentoAcessos.vue?vue&type=template&id=14e82df2&scoped=true"
import script from "./GerenciamentoAcessos.vue?vue&type=script&lang=js"
export * from "./GerenciamentoAcessos.vue?vue&type=script&lang=js"

import "./GerenciamentoAcessos.vue?vue&type=style&index=0&id=14e82df2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e82df2"]])

export default __exports__